import { getTypeDevice } from '../../utils/common';

const attrNav = 'data-nav-tabs-ui';
const attrContent = 'data-content-tabs-ui';
const tabs = document.querySelector('[data-tabs-ui]');

if (tabs) {
  let typeDevice = '';
  let oldTypeDevice = '';

  const navList = tabs.querySelectorAll(`[${attrNav}]`);
  const contentList = tabs.querySelectorAll(`[${attrContent}]`);
  const type = tabs.getAttribute('data-tabs-ui');

  const onClickSingleTab = (tab) => {
    if (!tab) {
      return;
    }

    const idCurrTab = tab.getAttribute(attrNav);

    navList.forEach((item) => {
      const idNav = item.getAttribute(attrNav);
      if (idNav === idCurrTab) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });

    contentList.forEach((item) => {
      const idContent = item.getAttribute(attrContent);
      if (idContent === idCurrTab) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  };

  const onClickMultipleTab = (tab) => {
    if (!tab) return;

    const idCurrTab = tab.getAttribute(attrNav);
    const currContent = tabs.querySelector(`[${attrContent}="${idCurrTab}"]`);
    const allActiveNavs = tabs.querySelectorAll(`[${attrNav}].active`);

    if (!idCurrTab || !currContent) return;

    // Если убираем галочку у последнего активного элемента
    if (allActiveNavs && allActiveNavs.length === 1 && tab.classList.contains('active')) {
      tab.classList.remove('active');
      contentList.forEach((item) => { item.classList.add('active'); });
    // Если не выбран ни один фильтр - для контента проставляем активность только нажатому
    } else if (!allActiveNavs || !allActiveNavs.length) {
      tab.classList.add('active');

      contentList.forEach((item) => {
        const idContent = item.getAttribute(attrContent);
        if (idContent === idCurrTab) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    } else if (tab.classList.contains('active')) {
      tab.classList.remove('active');
      currContent.classList.remove('active');
    } else {
      tab.classList.add('active');
      currContent.classList.add('active');
    }
  };

  const setTypeDevice = () => {
    if (type !== 'multiple') {
      return;
    }

    oldTypeDevice = typeDevice;
    typeDevice = getTypeDevice();

    if (!navList || !navList.length || !contentList || !contentList.length) {
      return;
    }

    if (oldTypeDevice !== typeDevice && (typeDevice === 'desktop' || oldTypeDevice === 'desktop')) {
      navList.forEach((item) => { item.classList.remove('active'); });
      contentList.forEach((item) => { item.classList.add('active'); });
    }
  };

  // Открытие таба, по параметру в урле
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('tab')) {
    const idTab = searchParams.get('tab');
    const tab = tabs.querySelector(`[${attrNav}="${idTab}"]`);

    onClickSingleTab(tab);
  }

  // Клик по кнопке таба
  navList.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (type === 'multiple') {
        onClickMultipleTab(tab);
      } else {
        onClickSingleTab(tab);
      }
    });
  });

  window.addEventListener('resize', setTypeDevice);
}

const selectTabs = tabs ? tabs.querySelectorAll('[data-select-tabs]') : null;
if (selectTabs && selectTabs.length) {
  selectTabs.forEach((select) => {
    import(
      /* webpackChunkName: "select-tabs" */
      './SelectTabsUI'
    ).then((partial) => partial.default(select));
  });
}
